export const TOGGLE_CACHE_TIMEOUT_MINUTES = 2;
export const TOGGLE_CACHE_TIMEOUT_SECONDS = TOGGLE_CACHE_TIMEOUT_MINUTES * 60;
export const TOGGLE_CACHE_TIMEOUT = TOGGLE_CACHE_TIMEOUT_SECONDS * 1000;
